import { render } from "./StandardHeaderHamburgerMenu.vue?vue&type=template&id=20d8c208&scoped=true"
import script from "./StandardHeaderHamburgerMenu.vue?vue&type=script&lang=js"
export * from "./StandardHeaderHamburgerMenu.vue?vue&type=script&lang=js"

import "./StandardHeaderHamburgerMenu.vue?vue&type=style&index=0&id=20d8c208&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d8c208"]])

export default __exports__